/*
UshasriDarla244 09/29/2022 2698947782 Customization in custom window
adityaa 09/29/2022 2698947782 Minor Changes
saikrishna 10/04/2022 2698947782 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
ashraf 10/06/2022 2698947782 fixed page break issue
saikrishna 10/06/2022 2698947782 Fixed custom window bug
saikrishna 10/06/2022 2698947782 Fixed merge conflicts
ashraf 10/06/2022 2698947782 added comments to code, removed unusual code
ashraf 10/07/2022 2698947782 removed commented code
ashraf 10/15/2022 2698947782 Added custom windows code comments
ashraf 10/15/2022 2698947782 restored code of window number state set to null
ashraf 10/27/2022  2698947782 custom window UX changes
suresh peddavoora 10/28/2022 2698947782  Modified styles for accordion root.
Ashraf 11/08/2022 2698947782 added field json validator in initial values.
Ashraf 11/28/2022 2698947782 added new fields to initial values
Gummala Prakash 11/28/2022 2698947782 updated card-style.
akhila 12/07/2022 2698947782 added default value for createdFor
*/

import React, {useState, useContext, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {makeStyles} from '@material-ui/core/styles';
import {ThemeContext} from '../../themes/ThemeProvider';
import UDWCreation from './UDWCreation';
import UDWAccordion from './UDWAccordion';

const useStyles = makeStyles((theme) => ({
  'root': {
    'flexGrow': 1,
    'width': '100%',
    'borderRadius': '5px',
    '& .MuiCard-root': {
      boxShadow: 'none !important',
    },
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
}));

// search window, add window tabs render (2698947782)

export default function CustomWindowSubTabs() {
  const classes = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [UDWData, setUDWData] = useState({});
  const [windowNumber, setWindowNumber] = useState(null);
  const [isCopyRowData, setIsCopyRowData] = useState(false);
  const [editExisting, setEditExisting] = useState(false);
  const {udwData} = useSelector(({udwWindows}) => udwWindows);
  const [formData, setFormData] = useState([]);
  const [editable, setEditable] = useState([]);
  const [changedWindowNumber, setChangedWindowNumber] = useState(false);

  // set windowNumber state to null on coming back to search tab (2698947782)
  useEffect(() => {
    setWindowNumber(null);
  }, []);
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  // initial state for window form (2698947782)
  const [initialValues, setInitialValues] = useState({
    type: 'none',
    windowCode: '',
    description: '',
    viewOnly: false,
    header: '',
    indicator: '',
    windowOwner: '',
    jsonValidator: '',
    createdFor: {userLoginName: user?.userName},
    category: '',
    orderBy: {},
    groupBy: {},
    orderDirection: 'asc',
  });
  const {udwStatus} = useSelector(({userDefinedWindow}) => userDefinedWindow);

  // on successful creation or updation of window resetting form state (2698947782)
  useEffect(() => {
    if (udwStatus === 200) {
      setWindowNumber(null);
      setInitialValues({
        type: 'none',
        windowCode: '',
        description: '',
        viewOnly: false,
        header: '',
        indicator: '',
        windowOwner: '',
        jsonValidator: '',
        createdFor: {userLoginName: user?.userName},
        category: '',
        orderBy: {},
        groupBy: {},
        orderDirection: 'asc',
      });
    }
  }, [udwStatus]);

  return (
    <>
      <div className={`${classes1.cardStyleWhite}`}>
        <h2 className="search-title">Custom Window Search</h2>
        <div className={classes.root}>
          <div className={classes.subContent}>
            {value === 0 && (
              <UDWAccordion
                setFormData={setFormData}
                setValue={setValue}
                changedWindowNumber={changedWindowNumber}
                setChangedWindowNumber={setChangedWindowNumber}
                setInitialValues={setInitialValues}
                setEditExisting={setEditExisting}
                setWindowNumber={setWindowNumber}
                setIsCopyRowData={setIsCopyRowData}
              />
            )}
            {value === 1 && (
              <UDWCreation
                setValue={setValue}
                setUDWData={setUDWData}
                UDWData={UDWData}
                changedWindowNumber={changedWindowNumber}
                editExisting={editExisting}
                setWindowNumber={setWindowNumber}
                windowsData={udwData}
                formData={formData}
                setFormData={setFormData}
                initialValues={initialValues}
                setInitialValues={setInitialValues}
                windowNumber={windowNumber}
                isCopyRowData={isCopyRowData}
                editable={editable}
                setEditable={setEditable}
                setIsCopyRowData={setIsCopyRowData}
                setEditExisting={setEditExisting}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
